module.exports = __webpack_public_path__ + "img/8.fbbdb553.png";